import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useAuth } from "@/contexts/AuthContext";
import { DeviceTrustPrompt } from "@/components/auth/DeviceTrustPrompt";
import { getDeviceChoice, setDeviceChoice, markActivity, markSessionStart, clearSessionTracking, type DeviceChoice } from "@/lib/deviceSession";

/**
 * Safety net for people who were already signed in before this device question
 * existed: ask it once, then never again on this device.
 */
export function DeviceTrustGate() {
  const { user, loading } = useAuth();
  const [answered, setAnswered] = useState(() => !!getDeviceChoice());

  const open = !loading && !!user && !answered;

  const choose = (choice: DeviceChoice) => {
    setDeviceChoice(choice);
    // Fresh start: drop anything left over from an earlier sign-in on this
    // browser so an old end time cannot sign this person straight back out.
    clearSessionTracking();
    markSessionStart();
    markActivity();
    setAnswered(true);
    // Reload so the sign-in length is applied from the answer straight away.
    window.location.reload();
  };

  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-md [&>button]:hidden">
        <DeviceTrustPrompt onChoose={choose} />
      </DialogContent>
    </Dialog>
  );
}
